var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderId, staticClass: "button-message-editor" },
    [
      _c("div", { staticClass: "text-editor-wrapper" }, [
        _c(
          "div",
          { staticClass: "text-editor" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.enterYourMessage"),
                "show-attributes":
                  _vm.showAttributes === undefined ||
                  _vm.showAttributes === true,
                "show-emoji":
                  _vm.showEmoji === undefined || _vm.showEmoji === true,
                "max-character-count": 640,
                "whatsapp-mode": _vm.whatsappMode,
                "allowed-attributes": _vm.allowedAttributes,
                "preview-mode": _vm.previewMode,
              },
              model: {
                value: _vm.clone.message,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "message", $$v)
                },
                expression: "clone.message",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons-wrapper" },
        [
          _vm._l(_vm.clone.buttons, function (button, i) {
            return _c(
              "div",
              { key: button.id, staticClass: "button-item" },
              [
                _c(
                  "a-popover",
                  {
                    key: button.id,
                    attrs: {
                      visible: _vm.editingButtonPopupVisibleMap[button.id],
                      placement: "left",
                      trigger: "click",
                      overlayClassName: "no-padding",
                    },
                    on: {
                      visibleChange: function (e) {
                        return _vm.visibleChange(button.id, e)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("ActionButtonUpdater", {
                          attrs: {
                            "on-completed": function () {
                              _vm.editingButtonPopupVisibleMap[
                                button.id
                              ] = false
                            },
                            "popup-visible":
                              _vm.editingButtonPopupVisibleMap[button.id],
                            flattedDiagram: _vm.flattedDiagram,
                            "whatsapp-mode": _vm.whatsappMode,
                            "allowed-attributes": _vm.allowedAttributes,
                          },
                          model: {
                            value: _vm.clone.buttons[i],
                            callback: function ($$v) {
                              _vm.$set(_vm.clone.buttons, i, $$v)
                            },
                            expression: "clone.buttons[i]",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "d-flex justify-content-center align-items-center w-100 h-100",
                        on: {
                          click: function ($event) {
                            return _vm.openEditButtonPopup(button.id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(button.title))]
                    ),
                    _vm._v(" "),
                    _vm.clone.buttons.length > 1
                      ? _c(
                          "div",
                          { staticClass: "button-controls" },
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button md-mini delete",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeButton(button.id)
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("delete_outline")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button md-mini",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.moveUpButton(button.id)
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("arrow_upward")])],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass: "md-icon-button md-mini",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.moveDownButton(button.id)
                                  },
                                },
                              },
                              [_c("md-icon", [_vm._v("arrow_downward")])],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.previewMode
            ? _c("div", { staticClass: "buttons-add" }, [
                _c("div", { staticClass: "buttons-add-line" }),
                _vm._v(" "),
                _c("div", { staticClass: "action-buttons-row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "buttons-add-wrapper",
                      on: { click: _vm.addButton },
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("div", { staticClass: "buttons-add-text" }, [
                        _vm._v(_vm._s(_vm.$t("chatbotv2.addButton"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.clone.buttons.length > 3
                    ? _c(
                        "div",
                        {
                          staticClass: "buttons-add-wrapper whatsapp-settings",
                          on: {
                            click: function ($event) {
                              _vm.showWhatsappSettings = true
                            },
                          },
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", { staticClass: "buttons-add-text" }, [
                            _vm._v("WhatsApp Ayarları"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showWhatsappSettings
        ? _c("WhatsappListSettingsModal", {
            attrs: { value: _vm.clone.whatsappListSettings },
            on: {
              save: _vm.handleWhatsappSettingsSave,
              cancel: function ($event) {
                _vm.showWhatsappSettings = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons-add-plus" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons-add-plus whatsapp-plus" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("settings")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }